import React from "react";
import { Typography, Card, CardContent, Rating } from "@mui/material";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Carlos M.",
    rating: 5,
    text: "I found out about AirKitchenz from a cashier at Restaurant Depot. I run a small restaurant and only open for dinner, so I figured why not try renting my kitchen during the day. It’s been smooth, already had two bookings last week.",
  },
  {
    name: "Jenny R.",
    rating: 4,
    text: "A friend of mine runs a catering business and told me about the platform. I started using it to rent a kitchen near Downtown LA for weekend gigs. It’s been a game changer with no contracts, no build-out, just book and cook.",
  },
  {
    name: "Luis T.",
    rating: 5,
    text: "My food supplier mentioned AirKitchenz, so I checked it out. I have a taqueria that’s closed in the mornings, and now a breakfast concept is using it, really easy way to monetize unused space.",
  },
  {
    name: "Angela P.",
    rating: 4,
    text: "We’re a bakery that only operates late night. We listed the kitchen and got inquiries in the first week. The support team helped us set it up right. Highly recommend it for restaurants looking to earn extra.",
  },
  {
    name: "Marcus D.",
    rating: 5,
    text: "AirKitchenz has helped me launch my small meal prep business. I couldn’t afford a lease on my own kitchen, but this platform gave me affordable access to a licensed space.",
  },
  {
    name: "Priya S.",
    rating: 4,
    text: "As a private chef, I need kitchens in different parts of the city. I love how easy it is to find and book kitchens that meet my needs and the reviews help a lot!",
  },
];

const Testimonials = () => {
  const loopedTestimonials = [...testimonials, ...testimonials];

  return (
    <div className="testimonials-section">
      <Typography variant="h2">What Our Users Say</Typography>
      <div className="testimonials-carousel-wrapper">
        <div className="testimonials-carousel">
          {loopedTestimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-slide">
              <Card className="testimonial-card">
                <div className="testimonial-content-wrapper">
                  <div className="avatar">{testimonial.name.charAt(0)}</div>
                  <Typography variant="h6" className="testimonial-name">
                    {testimonial.name}
                  </Typography>
                  <div className="testimonial-text-wrapper">
                    <Typography variant="body2" className="testimonial-text">
                      {testimonial.text}
                    </Typography>
                  </div>
                </div>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
